import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
    createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyle = definePartsStyle({
    list: {
        // Prevent flashing when hovering on non-list items.
        boxShadow: '2xl !important',

        // Avoid the original slow animation. Snapiness is king. (*♡∀♡)
        transform: 'none !important',
        transition: 'none !important',
        opacity: '1 !important',
    },
    item: {
        // Fix slow transition on hover, which is not acceptable. (╯°□°)╯︵ ┻━┻
        transition: 'none',
        fontSize: 'sm',
    },
    icon: {
        w: 5,
        h: 5,
    },
});

const themedMenu = defineMultiStyleConfig({ baseStyle });

export default themedMenu;
